import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

// Tracking clicks on the collapse button in SAIN answer cards
export const aiAnswerCollapseClicked: (
	props: commonAttributesType & { jiraNlToJqlCardVariant?: 'issue-table' | 'smartlink' },
) => AnalyticsEventPayload = (
	props: commonAttributesType & { jiraNlToJqlCardVariant?: 'issue-table' | 'smartlink' },
): AnalyticsEventPayload => {
	const { query, answerString, source, jiraNlToJqlCardVariant } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerCollapse',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			jiraNlToJqlCardVariant,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
